import React from 'react'

export default class TenantExperienceStatus extends React.Component {
  _isMounted = false

  constructor(props) {
    super(props)
    this.state = {
      status: null,
      selectedTenant: null,
    }
    this.environments = ['dev', 'test', 'int', 'pprod', 'prod']
  }

  componentDidMount() {
    const { tenant, selectedTenant, bookings } = this.props

    this._isMounted = true

    if (selectedTenant !== this.state.selectedTenant) {
      this.setState({ selectedTenant: selectedTenant, status: null })
    }
    const hasFrontend = bookings.some(
      (booking) => booking.serviceKey.toLowerCase() === 'frontend',
    )
    if (hasFrontend) {
      if (tenant.experiences.length) {
        this.getStatusLoop(tenant)
      } else {
        console.info('INFO: Tenant without experiences')
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.status) {
      return true
    }
    return false
  }

  getStatusLoop = async (tenant) => {
    let experiences = tenant.experiences
    let statusData = {}
    let allPromisesStatus = []

    experiences.forEach((experience) => {
      statusData[experience] = {}
      allPromisesStatus.push(
        this.getStatus(this.props.selectedTenant, experience),
      )
    })

    Promise.all(allPromisesStatus).then((allStatusData) => {
      allStatusData.forEach((item, key) => {
        statusData[item.experience] = item.envs
      })
      if (this._isMounted) {
        this.setState({ status: statusData })
      }
    })
  }

  getStatus(application, experience) {
    const { token } = this.props

    if (!this._isMounted) {
      return Promise.reject(new Error('fail'))
    }

    return new Promise((resolve, reject) => {
      fetch(
        `https://${process.env.TENANTS_API_HOST}/tdms/v1/status/${application}?experience=${experience}`,
        {
          method: 'GET',
          pragma: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        },
      )
        .then((resp) => resp.json())
        .then((status) => {
          if (status.envs) {
            status.experience = experience
            return resolve(status.envs ? status : {})
          }
          return reject({})
        })
    })
  }

  renderExperienceTable() {
    let versionKeys = []
    if (this.state.status && Object.keys(this.state.status).length) {
      let env = this.state.status[Object.keys(this.state.status)[0]]
      if (
        env &&
        env['dev'] &&
        env['dev'].details &&
        env['dev'].details.versions
      ) {
        versionKeys = Object.keys(env['dev'].details.versions)
      }
    }

    return Object.keys(this.state.status).map((exp, i) => {
      return (
        <React.Fragment key={`ExperienceStatus_table_${exp}`}>
          <p className="wb-type-copy-strong">Experience: {exp.toUpperCase()}</p>
          <div className="tenant-body__table-overflow">
            <table className="wb-table wb-table--striped wb-table--border-vertical wb-table--border-horizontal">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  {versionKeys &&
                    versionKeys.map((prop) => {
                      return <th key={exp + prop}>{prop.toUpperCase()}</th>
                    })}
                </tr>
              </thead>
              <tbody>
                {this.environments &&
                  this.environments.map((env, j) => {
                    return this.renderEnvironmentRow(exp, env, j)
                  })}
              </tbody>
            </table>

            <p className="wb-type-copy">
              Data collected from S3 asset storage, AEM author, AEM publisher
              and CDN asset storage.
            </p>
          </div>
        </React.Fragment>
      )
    })
  }

  renderEnvironmentRow(exp, env, envIndex) {
    if (this.state.status[exp] && this.state.status[exp][env]) {
      let envData = this.state.status[exp][env]
      let green = '#008a00'
      let red = '#e1292b'
      let statusColor = envData.status == 'UP' ? green : red
      let versions =
        envData.details && envData.details.versions
          ? envData.details.versions
          : {}

      return (
        versions && (
          <tr key={envIndex}>
            <th>
              <wb-icon
                style={{ color: statusColor }}
                name={
                  envData.status == 'UP' ? 'checkmark-circle' : 'alert-circle'
                }
              ></wb-icon>
            </th>
            <th>{env.toUpperCase()}</th>
            {Object.keys(versions).map((prop, i) => {
              if (versions[prop]) {
                let version = versions[prop]
                return <td key={env + prop + version}>{version}</td>
              }
            })}
          </tr>
        )
      )
    }
    return (
      <tr>
        <td>Not Available</td>
      </tr>
    )
  }

  render() {
    return (
      this.props.selectedTenant &&
      this.state.status && (
        <div className="tenant-body__block">
          <label className="tenant-body__block-label">CMS Versions</label>
          <div className="tenant-body__table">
            {this.renderExperienceTable()}
          </div>
        </div>
      )
    )
  }
}
